export default {
    async get(url, params){
        //await new Promise(r => setTimeout(r, 1000)).then({});
        return $.ajax({
            url: url,
            data: params,
            headers: {user_email: cookies.user_email, user_token: cookies.user_token},
            type: "GET"
        })
    },
    async post(url, params){
        return $.ajax({
            url: url,
            data: params,
            headers: {user_email: cookies.user_email, user_token: cookies.user_token},
            type: "POST"
        })
    },
    request(url, params, method){
        return $.ajax({
            url: url,
            data: params,
            headers: {user_email: cookies.user_email, user_token: cookies.user_token},
            type: method
        })
    }
}